module.exports = __webpack_public_path__ + "static/media/heroImage.4eb162c2.png";